(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const autoplaySpeed = 12;
  const manualPause = 6000;

  document.querySelectorAll('[data-bestsellers-carousel]').forEach((root) => {
    const carousel = root.querySelector('[data-product-carousel]');
    const track = root.querySelector('[data-product-track]');
    const sequences = Array.from(root.querySelectorAll('.pv2-product-sequence'));
    const previous = root.querySelector('[data-carousel-previous]');
    const next = root.querySelector('[data-carousel-next]');
    const toggle = root.querySelector('[data-carousel-toggle]');
    const toggleIcon = root.querySelector('[data-carousel-toggle-icon]');
    const toggleLabel = root.querySelector('[data-carousel-toggle-label]');
    if (!carousel || !track || sequences.length < 3 || !previous || !next || !toggle) return;

    let paused = reducedMotion.matches;
    let interacting = false;
    let hoverPaused = false;
    let focusPaused = false;
    let visible = true;
    let loopWidth = 0;
    let initialized = false;
    let resumeAt = 0;
    let previousTime = performance.now();

    const render = () => {
      root.classList.toggle('is-carousel-paused', paused);
      root.classList.toggle('is-motion-opted-in', !paused && reducedMotion.matches);
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      if (toggleLabel) toggleLabel.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      if (toggleIcon) toggleIcon.textContent = paused ? '▶' : 'Ⅱ';
    };

    const measure = () => {
      const oldLoopWidth = loopWidth;
      loopWidth = sequences[1].offsetLeft - sequences[0].offsetLeft;
      if (!loopWidth) return;
      if (!initialized) {
        carousel.scrollLeft = loopWidth;
        initialized = true;
        return;
      }
      if (oldLoopWidth && oldLoopWidth !== loopWidth) {
        carousel.scrollLeft = (carousel.scrollLeft / oldLoopWidth) * loopWidth;
      }
    };

    const wrapPosition = () => {
      if (!initialized || !loopWidth) return;
      if (carousel.scrollLeft < loopWidth * 0.5) carousel.scrollLeft += loopWidth;
      if (carousel.scrollLeft > loopWidth * 1.5) carousel.scrollLeft -= loopWidth;
    };

    const cardStep = () => {
      const cards = sequences[1].querySelectorAll('.pv2-product-card');
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      return Math.max(280, carousel.clientWidth * 0.76);
    };

    const pauseAfterManualAction = () => {
      resumeAt = performance.now() + manualPause;
    };

    const moveByCard = (direction) => {
      pauseAfterManualAction();
      carousel.scrollBy({ left: cardStep() * direction, behavior: 'smooth' });
    };

    const animate = (time) => {
      const elapsed = Math.min(64, time - previousTime);
      previousTime = time;
      wrapPosition();
      if (!paused && !interacting && !hoverPaused && !focusPaused && visible && !document.hidden && time >= resumeAt) {
        carousel.scrollLeft += autoplaySpeed * (elapsed / 1000);
      }
      requestAnimationFrame(animate);
    };

    previous.addEventListener('click', () => moveByCard(-1));
    next.addEventListener('click', () => moveByCard(1));

    carousel.addEventListener('pointerdown', () => {
      interacting = true;
      carousel.classList.add('is-user-interacting');
      pauseAfterManualAction();
    });

    const finishInteraction = () => {
      interacting = false;
      carousel.classList.remove('is-user-interacting');
      pauseAfterManualAction();
    };

    window.addEventListener('pointerup', finishInteraction, { passive: true });
    carousel.addEventListener('pointercancel', finishInteraction);
    carousel.addEventListener('wheel', pauseAfterManualAction, { passive: true });
    root.addEventListener('mouseenter', () => { hoverPaused = true; });
    root.addEventListener('mouseleave', () => { hoverPaused = false; });
    root.addEventListener('focusin', (event) => {
      focusPaused = Boolean(event.target.closest('.pv2-product-card'));
    });
    root.addEventListener('focusout', () => {
      focusPaused = false;
      pauseAfterManualAction();
    });

    toggle.addEventListener('click', () => {
      paused = !paused;
      render();
    });

    reducedMotion.addEventListener('change', (event) => {
      paused = event.matches;
      render();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        visible = entries[0]?.isIntersecting ?? true;
      }, { threshold: 0.05 });
      observer.observe(root);
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(track);
    }

    requestAnimationFrame(() => {
      measure();
      requestAnimationFrame(animate);
    });
    render();
  });
})();
